const staticContent = {
  section_1: {
    headingText:
      "We provide The Best To Protect Your Users And Their Investments",
    paragraphText:
      "Merklabs is a reputed name in the field of blockchain technology encompassing all the segments of this revolutionary field. Pioneering the essence of blockchain security and audits, we secure your present and future through the parameters of technology.",
  },
  section_2: {
    headingText: "Scale the world of DeFi",
    mainHeadingText: "DEFI",
    paragraphText:
      "Being the veterans in the blockchain industry, we understand the hype of decentralized finance and the contemporary optimizations in the financial sector and hence taking the grasp of the moment , we have developed exceptional projects in the world of DeFi.",
  },
  section_3: {
    headingText: "Technology made easier",
    mainHeadingText: "DAPPS",
    paragraphText:
      "Decentralized applications have found a huge user base right in the initial stage , and therefore we as a team have gained extensive expertise into the creation of dapps.",
  },
  section_4: {
    headingText: "Stay secure and safe",
    mainHeadingText: "AUDIT",
    paragraphText:
      "Above all that matters is a secure and safe smart contract that is free from any vulnerability and does not hamper the investment of the various people who have trusted you. We also provide auditing services , so that you can stay assured of the security as we are quick in auditing and exposing the bugs of your smart contract.",
  },
  section_5: {
    headingText: "Expert Review",
    mainHeadingText: "Expert",
    paragraphText:
      "Experience the guidance of various trained professionals and developers who are with you at every phase of your projects. We not only develop your project but also give out the best recommendations for turning it into a huge success",
  },
  section_6: {
    headingText: "Experience the Revolution",
    mainHeadingText: "SMART CONTRACT",
    paragraphText:
      "Merklabs has efficient developers with exceptional coding skills that can create any type of smart contract you desire and with scalable and secure code. You desire, we create it for you.",
  },
  section_7: {
    headingText: "Stabilize and Promote",
    mainHeadingText: "LAUNCHPAD",
    paragraphText:
      "Amidst the competition in the Defi space, good marketing strategy and implementation plays the key role to stabilize and promote your growth in the blockchain industry. Retaining this awareness, we can develop launchpad and IDO for your presale and ICO.",
  },
};

const countData = [
  {
    countValue: "100+",
    subText: "Blockchain companies protected",
  },
  {
    countValue: "200+",
    subText: "Issues discovered",
  },
  {
    countValue: "10,000+",
    subText: "Analyses available per month",
  },
];

module.exports = {
  staticContent,
  countData,
};
